import { isLoading } from '../../../constants/actionConstants';
import { ResetPassword,ResetPasswordValidation } from './service';
import { toast } from "react-toastify";




export function resetPasswordSave80iac(data) {
    return async function (dispatch) {
        const {email} = data;
        dispatch(isLoading(true));
        ResetPassword.resetPassword80iac(email).then(responce => {
            const { message, status } = responce;
            if (status) {
                toast.success(message)
            } else {
                toast.error(message)
            }
            dispatch(isLoading(false))
        }).catch(e => {
            toast.error(e)
            dispatch(isLoading(false))
        })

    }
}

export function resetPasswordValidationSave(data) {
    return async function (dispatch) {
        const { password } = data;
        dispatch(isLoading(true));
        try {
            const response = await ResetPasswordValidation.resetPasswordValidation(password);
            const { message, status } = response;
            if (status) {
                toast.success(message);
            } else {
                toast.error(message);
            }
            dispatch(isLoading(false));
            return response; 
        } catch (error) {
            toast.error(error.message || "An error occurred");
            dispatch(isLoading(false));
            throw error; 
        }
    };
}